export default {
    data() {
        return {
            success: {
                fullname: false,
                password: false,
                confirmPassword: false,
                referral: false,
                gender: false,
                tos: false,
                marketing: false
            },
            error: {
                fullname: "",
                password: "",
                confirmPassword: "",
                referral: "",
                gender: "",
                tos: "",
                marketing: ""
            },
            errorMessages: {
                fullnameRequired: {
                    el: "",
                    en: "Full Name is required",
                    it: ""
                },
                passwordRequired: {
                    el: "",
                    en: "Password is required",
                    it: ""
                },
                passwordLength: {
                    el: "",
                    en: "Password must be 6 characters long",
                    it: ""
                },
                confirmPasswordMatch: {
                    el: "",
                    en: "Must match password",
                    it: ""
                },
                referralRequired: {
                    el: "",
                    en: "Referral is required",
                    it: ""
                },
                genderRequired: {
                    el: "",
                    en: "Gender is required",
                    it: ""
                }
            }
        };
    },

    computed: {
        valid() {
            return (
                this.success.fullname &&
                this.success.password &&
                this.success.confirmPassword &&
                this.success.referral &&
                this.success.gender &&
                this.success.tos
            ); 
        }
    },

    methods: {
        validateFullname() {
            if (!this.user.full_name) {
                this.error.fullname = this.errorMessages.fullnameRequired[
                    this.lang
                ];
            } else {
                this.error.fullname = "";
            }
        },

        validatePassword() {
            if (!this.user.password) {
                this.error.password = this.errorMessages.passwordRequired[
                    this.lang
                ];
            } else if (this.user.password.length < 6) {
                this.error.password = this.errorMessages.passwordLength[
                    this.lang
                ];
            } else {
                this.error.password = "";
            }
        },

        validateConfirmPassword() {
            if (!this.user.password_confirmation) {
                this.error.confirmPassword = this.errorMessages.confirmPasswordMatch[
                    this.lang
                ];
            } else if (this.user.password_confirmation !== this.user.password) {
                this.error.confirmPassword = this.errorMessages.confirmPasswordMatch[
                    this.lang
                ];
            } else {
                this.error.confirmPassword = "";
            }
        },

        validateReferral() {
            if (!this.user.referral) {
                this.error.referral = this.errorMessages.referralRequired[
                    this.lang
                ];
            } else {
                this.error.referral = "";
            }
        },

        validateGender() {
            if (!this.user.gender) {
                this.error.gender = this.errorMessages.genderRequired[
                    this.lang
                ];
            } else {
                this.error.gender = "";
            }
        }
    },

    watch: {
        ["user.full_name"](val) {
            if (val) {
                this.success.fullname = !!val;
            } else {
                this.success.fullname = false;
            }
        },

        ["user.password"](val) {
            if (val) {
                this.success.password = val.length >= 6;
                this.success.confirmPassword = val === this.user.password_confirmation;
            } else {
                this.success.password = false;
            }
        },

        ["user.password_confirmation"](val) {
            if (val) {
                this.success.confirmPassword = val === this.user.password;
            } else {
                this.success.confirmPassword = false;
            }
        },

        ["user.referral"](val) {
            if (val) {
                this.success.referral = !!val;
            } else {
                this.success.referral = false;
            }
        },

        ["user.gender"](val) {
            if (val) {
                this.success.gender = !!val;
            } else {
                this.success.gender = false;
            }
        },

        ["user.tos"](val) {
            if (val) {
                this.success.tos = !!val;
            } else {
                this.success.tos = false;
            }
        },

        ["user.marketing"](val) {
            if (val) {
                this.success.marketing = !!val;
            } else {
                this.success.marketing = false;
            }
        },
    }
};
